import React from 'react';

export default function IconDE() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#464655"
                d="M32 7.506H0V1.069C0 .764.249.517.553.517H31.45c.304 0 .552.247.552.552v6.437Z"
            />
            <path
                fill="#FFE15A"
                d="M31.449 21.483H.552a.552.552 0 0 1-.551-.552v-6.437h32v6.437a.552.552 0 0 1-.552.552Z"
            />
            <path fill="#FF4B55" d="M32 7.506H0v6.988h32V7.506Z" />
        </svg>
    );
}
